import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import closeIcon from '../../theme/modal/closeIcon';
import { t } from '../../theme/locales';
const decodeHtmlEntities = (text)=>{
    if (typeof document === 'undefined') return text;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};
export const WishlistModal = ({ isOpen , isLoading =false , mode , title , initialValue ='' , onClose , onSubmit , list  })=>{
    const [value, setValue] = useState(initialValue);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const inputRef = useRef(null);
    useEffect(()=>{
        var _inputRef_current;
        setValue(initialValue);
        setConfirmDelete(false);
        if (!isOpen) return;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        const handleKeyDown = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, [
        isOpen,
        initialValue,
        onClose
    ]);
    if (!isOpen) return null;
    return h('div', {
        className: 'wishlist-modal is-open',
        'data-testid': 'wishlist-modal',
        role: 'dialog',
        'aria-modal': 'true',
        'aria-labelledby': 'wishlist-modal-title'
    }, [
        h('div', {
            className: 'wishlist-modal__overlay',
            onClick: onClose
        }),
        h('div', {
            className: 'wishlist-modal__container'
        }, [
            isLoading && h('div', {
                className: 'wishlist-modal__loading-layer'
            }),
            h('div', {
                className: 'wishlist-modal__header'
            }, [
                h('p', {
                    className: 'wishlist-modal__title',
                    id: 'wishlist-modal-title',
                    'data-testid': 'wishlist-modal-title'
                }, confirmDelete ? t('wishlist.delete_list') : title),
                h('button', {
                    type: 'button',
                    className: 'wishlist-modal__close-btn',
                    'data-testid': 'wishlist-modal-close-button',
                    'aria-label': t('wishlist.close_modal'),
                    onClick: onClose
                }, h(closeIcon, {}))
            ]),
            h('form', {
                className: 'wishlist-modal__body',
                style: {
                    pointerEvents: isLoading ? 'none' : 'auto'
                },
                onSubmit: (e)=>{
                    e.preventDefault();
                    const submitEvent = e;
                    const submitter = submitEvent.submitter;
                    var _submitter_getAttribute;
                    const submitMode = (_submitter_getAttribute = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute('data-submit-mode')) !== null && _submitter_getAttribute !== void 0 ? _submitter_getAttribute : mode;
                    if (submitMode === 'delete' && !confirmDelete) {
                        setConfirmDelete(true);
                        return;
                    }
                    onSubmit(e, value, submitMode);
                }
            }, [
                confirmDelete ? h('p', {
                    className: 'wishlist-modal__title'
                }, t('wishlist.delete_confirm') + ' ' + decodeHtmlEntities((list === null || list === void 0 ? void 0 : list.lname) || value) + '?') : h('input', {
                    ref: inputRef,
                    type: 'text',
                    className: 'wishlist-modal__input',
                    placeholder: t('wishlist.list_name_placeholder'),
                    value,
                    onInput: (e)=>setValue(e.target.value)
                }),
                h('div', {
                    className: 'wishlist-modal__footer wishlist-modal__footer-white wishlist-modal__footer-no-padding'
                }, [
                    confirmDelete ? h('button', {
                        type: 'submit',
                        className: 'wishlist-modal__submit-btn',
                        'data-submit-mode': 'delete'
                    }, t('wishlist.delete')) : h('button', {
                        type: 'submit',
                        className: 'wishlist-modal__submit-btn',
                        'data-submit-mode': mode,
                        disabled: !value.trim() || isLoading
                    }, mode === 'create' ? t('wishlist.create') : t('wishlist.edit')),
                    mode === 'edit' ? confirmDelete ? h('button', {
                        type: 'button',
                        className: 'wishlist-modal__cancel-btn',
                        onClick: ()=>setConfirmDelete(false)
                    }, t('wishlist.back')) : h('button', {
                        type: 'button',
                        className: 'wishlist-modal__cancel-btn',
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setConfirmDelete(true);
                        }
                    }, t('wishlist.delete')) : null
                ])
            ])
        ])
    ]);
};
